"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaskedTextField = void 0;
var react_1 = __importDefault(require("react"));
var react_text_mask_1 = __importDefault(require("react-text-mask"));
var react_2 = require("../../util/react");
var TextField_1 = require("../TextField");
function MaskedTextField(props) {
    var inputRef = props.inputRef, style = props.style, rest = __rest(props, ["inputRef", "style"]);
    var renderInput = function (ref, p) {
        return react_1.default.createElement(TextField_1.TextField, __assign({ style: style, inputRef: react_2.composeRefs(inputRef, ref) }, p));
    };
    return react_1.default.createElement(react_text_mask_1.default, __assign({ render: renderInput }, rest));
}
exports.MaskedTextField = MaskedTextField;
//# sourceMappingURL=MaskedTextField.js.map